import { useTranslation } from 'react-i18next'

import { useContentOverflow } from '../../../../hooks'
import { useFileDownload } from '../../../File'
import { FloatingTooltip } from '../../../Floating'

import { getItemText } from './ExportModalFilesListItem.utils'

import * as styles from './ExportModalFilesListItem.module.css'

function ExportModalFilesListItem({
  className = styles.ExportModalFilesListItem,
  exportLinkTitleKey = 'Request.ModalExportDownloadFileTextKey',
  id,
  index,
}) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const { downloadFile } = useFileDownload({ file: { id } })

  const text = getItemText({ exportLinkTitleKey, index, t })

  function handleDownloadFile() {
    return downloadFile()
  }

  return (
    <FloatingTooltip content={text} disabled={!overflow}>
      <div
        className={className}
        ref={setContentOverflowRef}
        onClick={handleDownloadFile}
      >
        {text}
      </div>
    </FloatingTooltip>
  )
}

export default ExportModalFilesListItem
